import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { getSubscriptions } from '../../services/groupsServices'
import { GlobalSubscriptions } from '../../components/UserGroups/interfaces'

export const useGetSubscriptions = (
    userGroupId: string,
    orgId: string,
    refetchOnMount = true,
): UseQueryResult<GlobalSubscriptions, Error> => {
    return useQuery<GlobalSubscriptions>({
        queryKey: ['userGroupSubscriptions', userGroupId, orgId],
        queryFn: async () => {
            if (!userGroupId) {
                return {} as GlobalSubscriptions
            }
            const response = await getSubscriptions(userGroupId, orgId)
            return response.globalSubscriptions
        },
        refetchOnWindowFocus: false,
        refetchOnMount,
    })
}
